import React from 'react';
import { Helmet } from 'react-helmet-async';
import { companyInfo } from '../mock';

const AboutPage = () => {
  return (
    <>
      <Helmet>
        <title>About Naru Tofu | Our Story & Mission</title>
        <meta name="description" content="Naru Tofu brings fresh Japanese-style tofu and soymilk to Bangalore — made with premium non-GMO soybeans, RO+UV water, traditional methods, and zero preservatives." />
        <link rel="canonical" href="https://narutofu.com/about" />
      </Helmet>
      <section className="section-padding" style={{ minHeight: '100vh' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <h1 className="hero-large" style={{ marginBottom: '48px', textAlign: 'center' }}>About Naru Tofu</h1>
          
          <div className="blog-content" style={{ lineHeight: '1.85' }}>
            <p className="body-large" style={{ marginBottom: '24px', color: 'var(--text-secondary)' }}>
              Naru Tofu began with a simple frustration: we could not find a clean, reliable everyday protein in Bangalore that we truly trusted.
            </p>

            <p className="body-regular" style={{ marginBottom: '24px', color: 'var(--text-secondary)' }}>
              As we looked more closely at daily food choices, we kept seeing the same gap — protein was often inconsistent, overly processed, or difficult to trust. We wanted something better: a protein source that was light, versatile, nutritious, and made to a higher standard.
            </p>

            <p className="body-regular" style={{ marginBottom: '24px', color: 'var(--text-secondary)', fontWeight: '500' }}>
              That search led us to Tofu.
            </p>

            <p className="body-regular" style={{ marginBottom: '24px', color: 'var(--text-secondary)' }}>
              For generations, tofu has been part of everyday food culture across Japan and much of Asia. It is simple, high in protein, easy to digest, and adaptable across cuisines. But in Bangalore, we felt tofu was still misunderstood or not made with the consistency and quality needed to become a true daily staple.
            </p>

            <p className="body-regular" style={{ marginBottom: '24px', color: 'var(--text-secondary)', fontWeight: '500' }}>
              So we started Naru Tofu.
            </p>

            <p className="body-regular" style={{ marginBottom: '24px', color: 'var(--text-secondary)' }}>
              Founded by <strong>Bisakha Maity</strong> and <strong>Surupam Chandra</strong>, Naru Tofu brings together a medical and nutrition-oriented perspective with a strong focus on food traceability, process, and quality control. What united us was a shared belief that better food begins with better standards.
            </p>

            <p className="body-regular" style={{ marginBottom: '24px', color: 'var(--text-secondary)' }}>
              We make fresh Japanese-style tofu and soymilk in Bangalore using premium non-GMO soybeans, RO+UV water, traditional methods, and zero preservatives. Every decision is intentional, because we believe simple food, made properly, can become a trusted part of everyday life.
            </p>

            <p className="body-regular" style={{ marginBottom: '0', color: 'var(--text-secondary)' }}>
              Naru Tofu is about more than tofu. It is about making clean protein more accessible, bringing greater trust to everyday food, and helping fresh, high-quality plant protein become a normal part of modern Indian diets.
            </p>
          </div>

          <div style={{ marginTop: '64px', padding: '32px', background: 'var(--bg-secondary)', border: '1px solid var(--border-light)', textAlign: 'center' }}>
            <h3 className="heading-2" style={{ marginBottom: '16px' }}>Our Certifications</h3>
            <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
              <strong>FSSAI:</strong> {companyInfo.manufacturing.fssai}
            </p>
            <p className="body-regular" style={{ marginTop: '8px', color: 'var(--text-secondary)' }}>
              <strong>GST:</strong> {companyInfo.billing.gst}
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutPage;
